(() => {
  const METADATA_KEYS = [
    "count",
    "product",
    "size",
    "quantity",
    "shape",
    "finish",
    "border",
    "easy_peel"
  ];

  function getBackupKeys(
    artworkId,
    artworkCount
  ) {
    const prefix =
      `__sc_upload_${artworkId}`;

    const keys =
      METADATA_KEYS.map(
        (name) =>
          `${prefix}_${name}`
      );

    for (
      let index = 1;
      index <= artworkCount;
      index += 1
    ) {
      keys.push(
        `${prefix}_${index}`
      );
    }

    return keys;
  }

  async function clearArtworkBackup(
    artworkId,
    artworkCount
  ) {
    if (!artworkId) {
      return;
    }

    const keys =
      getBackupKeys(
        artworkId,
        artworkCount
      );

    const attributes = {};

    keys.forEach((key) => {
      /*
       * An empty value clears this cart
       * attribute before checkout.
       */
      attributes[key] = "";
    });

    const root =
      window.Shopify?.routes?.root ||
      "/";

    const response = await fetch(
      `${root}cart/update.js`,
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",

          Accept:
            "application/json"
        },

        body: JSON.stringify({
          attributes
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        `Artwork cleanup failed: ${response.status}`
      );
    }

    console.log(
      "Sticker artwork backup cleared:",
      artworkId
    );
  }

  document.addEventListener(
    "click",
    async (event) => {
      const removeButton =
        event.target.closest(
          "cart-remove-button[data-sc-artwork-id]"
        );

      if (!removeButton) {
        return;
      }

      /*
       * The second click is the one we allow
       * through to Dawn after cleanup.
       */
      if (
        removeButton.dataset
          .scArtworkCleanupComplete ===
        "true"
      ) {
        return;
      }

      const removeLink =
        event.target.closest("a");

      if (!removeLink) {
        return;
      }

      const artworkId =
        removeButton.dataset
          .scArtworkId;

      const artworkCount =
        Number.parseInt(
          removeButton.dataset
            .scArtworkCount,
          10
        ) || 0;

      /*
       * Stop Dawn from removing the line
       * until its private cart attributes
       * have been cleared.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      if (
        removeButton.dataset
          .scArtworkCleanupRunning ===
        "true"
      ) {
        return;
      }

      removeButton.dataset
        .scArtworkCleanupRunning =
        "true";

      try {
        await clearArtworkBackup(
          artworkId,
          artworkCount
        );
      } catch (error) {
        /*
         * Don't trap the customer in the cart
         * if Shopify's attribute cleanup fails.
         */
        console.error(
          "Sticker artwork cleanup error:",
          error
        );
      }

      removeButton.dataset
        .scArtworkCleanupComplete =
        "true";

      delete removeButton.dataset
        .scArtworkCleanupRunning;

      /*
       * Re-trigger the original remove action.
       * This time our listener allows Dawn
       * to handle it normally.
       */
      removeLink.click();
    },
    true
  );
})();